import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { MessagesIcon } from 'foundations-assets/icons/components/MessagesIcon';
import { AcademyAssistantIcon } from './AcademyAssistantIcon';
import { NewChatIcon } from './NewChatIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChatHeader = ({
  hasMessages,
  onClose,
  onNewChat,
  onOpenChats,
  trackEvent
}) => {
  const {
    isMobile,
    isMobileNavbar
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "300",
    borderBlockEndWidth: "100",
    borderColor: "border-core-default",
    blockSize: "50px",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      inlineSize: "100%",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        flex: 1,
        justifyContent: "start",
        children: [/*#__PURE__*/_jsx(Button, {
          use: "unstyled",
          size: "extra-small",
          onClick: () => {
            trackEvent('chat-closed');
            onClose();
          },
          flex: "0",
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "25",
            children: [/*#__PURE__*/_jsx(LeftIcon, {
              size: "100"
            }), /*#__PURE__*/_jsx(Text, {
              typography: "detail-100",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academy-ai-assistant.chat.back"
              })
            })]
          })
        }), !isMobile && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(AcademyAssistantIcon, {
            size: 28
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academy-ai-assistant.chat.title"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [isMobileNavbar ? /*#__PURE__*/_jsx(ActionsMenu, {
          referenceIndicator: /*#__PURE__*/_jsx(VerticalMenuIcon, {
            size: "200"
          }),
          shape: "circle",
          use: "transparent",
          referenceSize: "compact",
          menuInlineSize: 160,
          actions: [{
            text: I18n.text('academy-ai-assistant.drawer.title'),
            value: 'chats',
            indicator: /*#__PURE__*/_jsx(MessagesIcon, {
              size: "100"
            })
          }],
          onActionClick: ({
            value
          }) => {
            if (value === 'chats') {
              trackEvent('history-drawer-opened');
              onOpenChats();
            }
          }
        }) : null, hasMessages ? /*#__PURE__*/_jsx(Tooltip, {
          placement: "bottom left",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academy-ai-assistant.chat.newChatTooltip"
          }),
          children: /*#__PURE__*/_jsx(View, {
            as: "span",
            display: "inline-block",
            padding: "100",
            children: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": I18n.text('academy-ai-assistant.chat.newChat'),
              onClick: () => {
                trackEvent('new-chat-started');
                onNewChat();
              },
              shape: "circle",
              use: "transparent",
              size: "sm",
              children: /*#__PURE__*/_jsx(NewChatIcon, {
                size: 28
              })
            })
          })
        }) : null]
      })]
    })
  });
};